/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("CanvasController", ["ControllerBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class CanvasController
   * @memberOf classes
   * @extends classes.ControllerBase
   */
  class CanvasController extends cls.ControllerBase /** @lends classes.CanvasController.prototype */ {
    static __name = "CanvasController";

    // _afterLayoutHandler is assigned in _initBehaviors (invoked during super()
    // construction), so it is intentionally not declared as a class field: a field
    // initializer would run after super() and clobber that value.

    _initBehaviors() {
      super._initBehaviors();
      this._addBehavior(cls.LayoutInfoVMBehavior);
      this._addBehavior(cls.Border4STBehavior);
      this._addBehavior(cls.Reverse4STBehavior);

      const layoutService = this.getAnchorNode().getApplication().layout;
      this._afterLayoutHandler = layoutService.afterLayout(this.onAfterLayout.bind(this));
    }

    destroy() {
      if (this._afterLayoutHandler) {
        this._afterLayoutHandler();
      }
      super.destroy();
    }

    onAfterLayout() {
      const children = this.getAnchorNode().getChildren();
      for (const element of children) {
        const ctrl = element.getController();
        if (ctrl.onAfterLayout) {
          ctrl.onAfterLayout();
        }
      }
    }
  }

  cls.CanvasController = CanvasController;
  cls.ControllerFactory.register("Canvas", cls.CanvasController);
});
